__webpack_require__.p = "/twinpeaks/";